export const DARK_THEME = "DARK_THEME";